import { createContext, ReactNode, useMemo } from 'react';
import { useAssignmentsQuery } from '../query';
import { AssignmentsContextState } from '../types';

export const AssignmentsContext = createContext<
  AssignmentsContextState | undefined
>(undefined);

export const AssignmentsContextProvider = ({
  children
}: {
  children: ReactNode;
}) => {
  const { data, isLoading, isError, error } = useAssignmentsQuery();

  const contextValue = useMemo(
    () => ({
      assignmentsList: data ? data.data ?? [] : undefined,
      isError,
      error,
      isLoading
    }),
    [data, error, isError, isLoading]
  );

  return (
    <AssignmentsContext.Provider value={contextValue}>
      {children}
    </AssignmentsContext.Provider>
  );
};
